import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { StickyNote } from "lucide-react";

import type { FeatureModule } from "@/features/types";

import { PlanningSessionPage } from "./pages/PlanningSessionPage";
import { PlanningSessionsPage } from "./pages/PlanningSessionsPage";

export const planningModule: FeatureModule = {
  key: "planning",
  nav: {
    label: "Planning",
    icon: StickyNote,
    to: "/planning",
    // Access is per-session (invites), enforced by the backend: any signed-in
    // user can open the page and sees exactly the sessions they're part of.
    requires: "",
    order: 103,
    group: "Strategy",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/planning",
      component: PlanningSessionsPage,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/planning/$sessionId",
      component: PlanningSessionPage,
    }),
  ] as unknown as AnyRoute[],
};
